<div class="row">
     <div class="col-12">
         <div class="row justify-content-between align-items-center" id="page-title">
             <h1 class="progress-header col-12 col-lg-auto">
                 {{ 'Enroll in PSP_MAIN' | translator:'base'}}
             </h1>
         </div>
         <div class="row mb-2">
             <span class="col-12 col-lg-auto d-flex align-items-center small">
                 <i class="fas fa-triangle-exclamation me-2" aria-hidden="true"></i>
                 <span [innerHTML]="'Start_8-1' | translator:'base'">
                     Are you a <strong>driver</strong> looking for your own PSP record?
                 </span>
                 <a routerLink="/driver/1"
                     (click)="scrollToTop()"
                     name="Driver-record-request"
                     id="Driver-record-request"
                     [title]="'Start_8-2' | translator:'base'" 
                     class="ms-1" 
                 >
                     <span [innerHTML]="'Start_8-2' | translator:'base'">Access your PSP record here.</span>
                 </a>
             </span>
         </div>
         <div class="row">
             <div class="col-lg-8">
                 <div class="card shadow-sm rounded-0 border-0">
                     <div class="card-body">
                         <app-complete-bar [step]="5" [totalSteps]="19"></app-complete-bar>
                         <h2 [innerHTML]="'CompanyInformationMAH' | translator:'base'">
                             MONTHLY ACCOUNT HOLDER
                         </h2>
                         <hr>
                         <fieldset>
                             <legend class="form-label">
                                 <span [innerHTML]="'CompMACT_2' | translator:'base'">
                                     What does your company transport?
                                 </span>
                                 <span class="text-danger text-center ms-1" [title]="'Required' | translator:'base'">*</span>
                             </legend>
                             <div class="form-check">
                                 <label class="form-check-label">
                                     <input type="radio" name="carrierType" id="carrierTypeFreight" class="form-check-input"
                                         [(ngModel)]="enrollmentService.newCustomer!.motorPassengerCarrier" value="Motor Carrier" required />
                                     <span [innerHTML]="'CompMACT_3' | translator:'base'">
                                         Freight (I am a motor carrier)</span>
                                 </label>
                             </div>
                             <div class="form-check">
                                 <label class="form-check-label">
                                     <input type="radio" name="carrierType" id="carrierTypePeople" class="form-check-input"
                                         [(ngModel)]="enrollmentService.newCustomer!.motorPassengerCarrier" value="Passenger Carrier" required />
                                     <span [innerHTML]="'CompMACT_4' | translator:'base'">
                                         People (I am a passenger carrier)</span>
                                 </label>
                             </div>
                             <div class="form-check">
                                 <label class="form-check-label">
                                     <input type="radio" name="carrierType" id="carrierTypeBoth" class="form-check-input"
                                         [(ngModel)]="enrollmentService.newCustomer!.motorPassengerCarrier" value="Both" required />
                                     <span [innerHTML]="'CompMACT_5' | translator:'base'">
                                         Both (I am both a motor carrier and a passenger carrier)</span>
                                 </label>
                             </div>
                         </fieldset>
                         <div class="d-flex flex-row-reverse justify-content-between mt-4 btn-group-wizard">
                             <div class="btn-group" role="group">
                                 <button routerLink="/signup/10" tag="button" class="btn btn-primary btn-strong"
                                     [disabled]="pageValid()" [title]="'MAHInfo' | translator:'base'" (click)="scrollToTop()"
                                     name="companyNext8" id="companyNext8">
                                     <span [innerHTML]="'Continue' | translator:'base'">Continue</span>
                                     <span class="sr-only">&nbsp;</span>
                                     <span class="sr-only" [innerHTML]="'MAHInfo' | translator:'base'">Monthly Account Holder Info</span>
                                 </button>
                             </div>
                             <div class="btn-group" role="group">
                                 <button routerLink="/signup/6" tag="button" class="btn btn-outline-primary"
                                     [title]="'MAHInfo' | translator:'base'" name="companyBack8" id="companyBack8"
                                     >
                                     <span [innerHTML]="'Back' | translator:'base'">Back</span>
                                     <span class="sr-only" [innerHTML]="'MAHInfo' | translator:'base'">Monthly Account Holder Info</span>
                                 </button>
                                 <button routerLink="/" tag="button" class="btn btn-light" (click)="scrollToTop()"
                                     name="companyCancel8" id="companyCancel8"
                                     [innerHTML]="'Cancel' | translator:'base'"
                                     [title]="'Cancel' | translator:'base'">
                                     Cancel
                                 </button>
                             </div>
                         </div>
                     </div>
                 </div>
             </div>
             <app-progress-wizard [wizardObj]="wizardObj" [activeStep]="2"
                    [pageType]="enrollmentService.newCustomer!.customerType || '-'"
                    class="col-lg-4 sidebar d-none d-lg-block"></app-progress-wizard>
         </div>
     </div>
 </div>
